import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receiving-accounts',
  templateUrl: './receiving-accounts.component.html',
  styleUrls: ['./receiving-accounts.component.scss']
})
export class ReceivingAccountsComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }
}
